<template>
	<t-popover
		:showPopover="popoverIsVisible"
		:marginY="6"
		position="bottom"
		v-bind="$attrs"
	>
		<div
			slot="target"
			:class="[{flex: flex}]"
			@mouseenter="popoverIsVisible = true"
			@mouseleave="popoverIsVisible = false"
		>
			<slot name="target" />
		</div>
		<slot/>
	</t-popover>
</template>

<script>
export default {
	name: 'TToolTip',
	inheritAttrs: false,
	props: { flex: Boolean },
	data() {
		return { popoverIsVisible: false };
	}
};
</script>

<style lang="scss" scoped>
.flex {
	display: flex;
	flex-grow: 1;
}
</style>